import useFetchedData from 'hooks/useFetchedData'
import ProfileItem from 'components/ProfileItem'
import { useNavigate } from 'react-router-dom'
import MapSimple from 'pages/MapSimple'
import Loader from 'components/Loader'
import TopBar from 'components/Topbar'
import { useState } from 'react'
import * as urls from 'api/urls'
import './index.scss'

const SavedProfiles: React.FC = () => {
  const { data, isLoading } = useFetchedData<places.PlacesResponse>(urls.places)
  const [mapVisible, setMapVisible] = useState<boolean>(false)
  const navigate = useNavigate()

  const savedBoards = data?.savedBoards || []
  const filteredMyBoards = (data?.myBoards || []).filter(
    board => board.biography === null && board.qr_id === null
  )

  const combinedBoards = [...savedBoards, ...filteredMyBoards].sort((a, b) =>
    a.name.localeCompare(b.name)
  )

  return (<>
    {isLoading
      ? <Loader type='full' />
      : <div className='savedProfiles'>
        <TopBar isSticky={true} theme='dark' title='Zapisane pomniki' />
        <div className="switch">
          <span className={`${mapVisible ? '' : 'active'}`} onClick={() => setMapVisible(false)}>Lista</span>
          <span className={`${mapVisible ? 'active' : ''}`} onClick={() => setMapVisible(true)}>Mapa</span>
        </div>
        <div className="savedProfiles__content" style={mapVisible ? { padding: '0' } : undefined}>
          {mapVisible
            ? <MapSimple body={data} />
            : combinedBoards.length > 0
              ? combinedBoards.map(board => {
                const isFilteredMyBoard = filteredMyBoards.some(filteredBoard => filteredBoard.id === board.id)
                return (
                  <ProfileItem
                    id={board.id}
                    notification={isFilteredMyBoard ? -1 : undefined}
                    key={board.id}
                    img={board.img}
                    name={board.name}
                    isPaid={true}
                    action={() => navigate(isFilteredMyBoard ? `/profilepin/${board.id}` : `/profile/${board.id}`)}
                  />
                )
              })
              : <div className='empty'>Brak zapisanych pomników</div>}
        </div>
      </div>}
  </>)
}

export default SavedProfiles